import { MarketoForm } from '../generated/graphql';

import { MarketoFormField } from '../types/types';

export const getProcessedValue = (
  field:
    | {
        processed?: string | null | undefined;
      }
    | null
    | undefined
) => {
  if (field) {
    return field.processed ? field.processed : '';
  }
  return '';
};

export const getMarketoForm = (
  marketoForms: { [key: string]: MarketoForm },
  fieldMarketoForm?: MarketoFormField | null
) => {
  const marketoEntity = fieldMarketoForm ? fieldMarketoForm.entity : null;
  const marketoId = marketoEntity ? marketoEntity.fieldMarketoId : null;
  const marketoForm = marketoId ? marketoForms![marketoId] : null;
  return marketoForm;
};
